import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const calculateTotalMinutes = (time: string, separator: string = ':'): number => {
  const [hours, minutes] = time.split(separator).map(Number);
  return hours * 60 + minutes;
};

export const endTimeAfterStartTimeValidator: (startTimeControlName?: string, timeSeparator?: string) => ValidatorFn =
  (startTimeTitle = 'startTime', timeSeparator = ':') => (control: AbstractControl): ValidationErrors | null => {
    const parent = control.parent;
    if (!parent) return null;

    const startTime = parent.get(startTimeTitle)?.value;
    const endTime = control.value;
    if (!startTime || !endTime) return null;

    const startTotalMinutes = calculateTotalMinutes(startTime, timeSeparator);
    const endTotalMinutes = calculateTotalMinutes(endTime, timeSeparator);

    return endTotalMinutes > startTotalMinutes ? null : { endTimeBeforeStartTime: true };
  };
